import WebError from './WebError'

export default class ServerError extends WebError {}